<template>
  <div id="buy">
    <div class="buy_nav"></div>
    <div class="buy_container">
      <div class="buy_containers">
        <div class="buy_title">因子列表</div>
        <div class="buy_detail">
          <!-- <p class="title">一、因子列表</p> -->
          <table class="buytable" style="margin-top:30px">
            <tr>
              <td width="90px" style="text-align:center;">因子类别</td>
              <td width="170px" style="text-align:center">分类</td>
              <td style="text-align:center">说明</td>
              <td width="140px" style="background:#c75438;color:white;text-align:center">数量</td>
            </tr>
            <tr>
                <td rowspan="12" style="text-align:center">股票因子</td>
                <td>量价类-技术指标</td>
                <td rowspan="6">技术、波动率、换手率、成交量等量价类因子和强弱度、流动性效率等特色因子；</td>
                <td width="100px">27</td>
            </tr>
            <tr>
                <td>量价类-波动率因子</td>
                <td >4</td>
            </tr>
            <tr>
                <td>量价类-换手率因子</td>
                <td>3</td>
            </tr>
            <tr>
                <td>量价类-成交量因子</td>
                <td>4</td>
            </tr>
            <tr>
                <td>量价类-资金流向因子</td>
                <td>3</td>
            </tr>
            <tr>
                <td>量价类-横向比较</td>
                <td>1</td>
            </tr>
            <tr>
                <td>财务类-盈利能力</td>
                <td rowspan="6">盈利、成长、市场估值、持股结构等常用因子和净现比等特色因子；</td>
                <td>10</td>
            </tr>
            <tr>
                <td>财务类-财务质量</td>
                <td>11</td>
            </tr>
            <tr>
                <td>财务类-成长性</td>
                <td>5</td>
            </tr>
            <tr>
                <td>财务类-盈利预测</td>
                <td>3</td>
            </tr>
            <tr>
                <td>财务类-市场估值</td>
                <td>9</td>
            </tr>
            <tr>
                <td>公司资料类-持股结构</td>
                <td>3</td>
            </tr>
           
            <tr>
                <td rowspan="4" style="text-align:center">可转债因子</td>
                <td>市场估值类</td>
                <td rowspan="4">可转债估值、量价、正股特征等常用因子和BS定价期权价值/溢价率等特色因子；</td>
                <td>23</td>
            </tr>
            <tr>
                <td>量价类</td>
                <td>8</td>
            </tr>
            <tr>
                <td>正股财报类</td>
                <td>9</td>
            </tr>
            <tr>
                <td>正股量价类</td>
                <td>6</td>
            </tr>
            <tr class="kongbai">
              <td>因子总计</td>
              <td colspan="2"></td>
              <td style="color: rgb(202, 67, 67);font-weight: bold;font-size: 18px;text-align:center;padding-right:0">133</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped>
.daozhuan{
      transform: rotateX(180deg);
}
.leftyc{
    padding: 21px 0!important;
}
.left {
  text-align: left !important;
  padding-left: 10px !important;
}
.href {
  color: #3888ff;
  /* text-decoration: underline; */
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  vertical-align: middle;
}
.title {
  margin-top: 30px;
  font-size: 18px;
  color: #666;
  font-weight: bold;
}
.buytable {
  margin-top: 15px;
}

.buytable tr {
  /* height: 35px; */
  vertical-align: middle;
  color: #4c4c4c;
  font-size: 14px;
}
.buytable tr:first-child > td {
  padding: 6px 0 !important;
  line-height: 24px;
}
.buytable td {
  padding-left: 50px;
  vertical-align: middle;
  line-height: 20px;
  color: #4d4d4d;
}
.buytable tr td:first-child {
  padding-left: 0px;
  text-align: center;
}
.buytable2 td{
  line-height: 20px;
  padding: 8px 0;
  text-align: center !important;
  padding-right: 0 !important;
}

.lightTr {
  background: #f7f7f7;
}
.buytable tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  background: #c75438;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.buytable tr:first-child td {
  padding-left: 0;
  color: inherit;
}
.buytable tr td:nth-last-child(4) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:2px 10px;
}
.buytable tr td:nth-last-child(3) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:4px 8px;
}
.buytable tr td:nth-last-child(2) {
  /* background: #fffff9; */
  text-align: justify;
  padding: 4px 8px;
}
/* .buytable tr td:nth-last-child(2) {
  text-align: center;
  padding-left: 0;
} */
.buytable tr td:nth-last-child(1) {
  /* background: #fffff9; */
  text-align: center;
  padding-left: 0;
}
.firstline td:first-child {
  text-align: center;
  padding: 0 !important;
}
/*.firstline td:nth-child(2){
  background: none  !important;
}
.firstline td:nth-child(3){
  background: #fef7fa !important;
}
.firstline td:nth-child(4){
  background: #fffff9;
} */
.col td {
  background: white !important;
  text-align: left !important;
  padding-left: 50px !important;
}
.col td:last-child {
  padding-left: 90px !important;
}
#buy {
  position: relative;
  color: #7b7b7b;
}
.buy_nav {
  height: 488px;
  width: 100%;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=54) no-repeat center top;
}
.buy_container {
  width: 1050px;
  height: 100%;
  position: relative;
  margin: -252px auto 0 auto;

  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 20px -5px #ccc;
}
.buy_containers {
  padding: 30px 30px 40px 30px;
}
.buy_title {
  font-size: 22px;
  line-height: 40px;
  border-bottom: 1px dashed #a8a8a8;
}

.buy_detail {
  position: relative;
  min-height: 460px;
  width: 840px;

  margin: 0 auto;
}

.contactUs {
  height: 47px;
  line-height: 47px;
  width: 198px;
  text-align: center;
  background-color: #cb4848;
  color: #fff;
  border-radius: 23px;
  margin: 102px auto 0 auto;
}

.yuyue {
  /* height: 330px; */
  background: #fef8f5;
  padding: 20px 125px;
  margin-bottom: 10px;
  width: 500px;
}
.yuyue input {
  margin: 10px 0;
}
.yuyue h3 {
  text-align: center;

  font-size: 20px;
  line-height: 25px;
  color: #7f8080;
  padding-top: 15px;
}
.yuyue p {
  font-size: 16px;
  line-height: 30px;
  color: #bc734d;
  margin-bottom: 15px;
}
.yuyue input {
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding-left: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 320px;
}
.yuyue h4 {
  width: 85px;
  letter-spacing: 5px;
  line-height: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline-block;
  text-align: right;
  padding-right: 8px;
}
.shengfen {
  width: 140px;
  display: inline-block;
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  line-height: 30px;
  padding-left: 10px;
  letter-spacing: 2px;
}
.selectt {
  width: 30px;
  height: 30px;
  background: url(../../assets/img/xia.png) no-repeat;
  color: white;
  float: right;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.xiala {
  width: 150px;
  float: right;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  height: 100px;
  overflow-y: scroll;
}
.xiala li {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.xiala li:hover {
  background: #ffeded;
}
.sub {
  width: 100px;
  background: #a45544;
  border-radius: 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  color: white;
  margin-top: 15px;
  cursor: pointer;
}
/* input:-internal-autofill-selected{
    background: white;
  } */
input:-internal-autofill-selected {
  background: black;
}
.buytable td {
  border: 1px solid #e6e4e4;
  border-bottom: 1px solid #bcbaba;
}
.buytable img {
  position: absolute;
  /* margin-left: 6px; */
  margin-bottom: 4px;
}
.zhu {
  background: #a7152e;
  margin-top: 20px;
  color: white;
  padding-left: 7px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  width: 50px;
  border-radius: 0 20px 20px 0;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  /* text-indent: 2em; */
  /* padding-left: 37px; */
}
.zhushia {
  /* padding-left: 15px; */
}

.num_text {
  color: #b83616;
  font-size: 16px;
  /* margin-left: 20px; */
}
.txt_l {
  height: 29px;
  line-height: 29px;
}
.yuanchaung{
  position: absolute;
  top: -14px;
  left: -15px;
  /* width: 24px; */
}
.jiabcen{
  padding: 10px 0;
  text-align: center;
  padding-left: 0 !important;
}
.tipsss{
  border:1px solid #e6e4e4;
  border-top:none;
  padding: 20px;
}
.kongbai td:nth-child(1){
  text-align:  center !important;
  padding-right: 10px !important;
  
}
.kongbai td:nth-child(3){
  font-weight: bold;
  
}
/* .kongbai td:nth-child(2),.kongbai td:nth-child(3){
  border: none;
}
.kongbai td:nth-child(1){
  border-right: none;
}
.kongbai td:nth-child(4){
  border-left: none;
} */
</style>